const featureSelector = document.querySelector(".feature-selector");
const features = document.querySelectorAll(".feature");

if (featureSelector) {
    featureSelector.addEventListener("change", (e) => {
        const selectedFeature = e.target.value;
        features.forEach((feature) => {
            if (feature.id === `${selectedFeature}-feature`) {
                feature.classList.remove("hidden");
            } else {
                feature.classList.add("hidden");
            }
        });
    });
}

const copyrightYear = document.getElementById("copyright-year");

if (copyrightYear) {
    copyrightYear.textContent = new Date().getFullYear().toString();
}
